import { render } from "./PayPassword.vue?vue&type=template&id=0c88a062&scoped=true"
import script from "./PayPassword.vue?vue&type=script&lang=js"
export * from "./PayPassword.vue?vue&type=script&lang=js"

import "./PayPassword.vue?vue&type=style&index=0&id=0c88a062&lang=scss&scoped=true"
import "./PayPassword.vue?vue&type=style&index=1&id=0c88a062&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c88a062"]])

export default __exports__